import {
  IQuickVideoForm,
  QuickVideoEmailSmsValues,
} from 'lib/api/quickVideo/types';
import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import { Typography } from 'react-covideo-common';
import { useFormikContext } from 'formik';
import { CustomizeEmailSmsComponent } from '../CustomizeEmailSmsComponent';
import { useTheme } from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from 'lib/components/SegmentedControl';

export const QuickVideoCustomizeEmailSmsForm = () => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext<IQuickVideoForm>();
  const theme = useTheme();

  const selectedValue = values.generateEmailSmsContent
    ? QuickVideoEmailSmsValues.GENERATE_WITH_AI
    : QuickVideoEmailSmsValues.CUSTOMIZE_SCRIPT;

  return (
    <Flex gap='20px'>
      <Typography
        color={theme.colors.neutral[80]}
        variant='small'
        fontWeight={600}
      >
        {t('Email / SMS Script')}
      </Typography>

      <SegmentedControl
        initialValue={selectedValue}
        values={[
          {
            value: QuickVideoEmailSmsValues.GENERATE_WITH_AI,
            label: t(QuickVideoEmailSmsValues.GENERATE_WITH_AI),
          },
          {
            value: QuickVideoEmailSmsValues.CUSTOMIZE_SCRIPT,
            label: t(QuickVideoEmailSmsValues.CUSTOMIZE_SCRIPT),
          },
        ]}
        onChange={value => {
          setFieldValue(
            'generateEmailSmsContent',
            value === QuickVideoEmailSmsValues.GENERATE_WITH_AI ? 1 : 0
          );
        }}
      />

      <CustomizeEmailSmsComponent />
    </Flex>
  );
};
